'use client';

import Link from 'next/link';
import Image from 'next/image';
import { DEMO_PATH, HOME_PATH } from '@/constants/paths';
import useAuth from '@/lib/firebase/auth/store';
import useTranslations from '@/hooks/useTranslations';

interface LogoProps {
  height?: number;
  demoMode?: boolean;
  backButton?: boolean;
}

const Logo = ({ height = 24, demoMode, backButton }: LogoProps) => {
  const { userData } = useAuth();
  const { t } = useTranslations();

  // Whitelabel (#YvSMeUg3): a company logo replaces the OrthoSolid one for its
  // own users. Logged out there is no company and no logo, so the auth pages and
  // the marketing site keep the static file.
  const companyLogo = userData?.company?.logo;

  // Don't show the logo on the demo pages
  const showCompanyLogo = companyLogo && !demoMode;

  // The alt announces the brand actually on screen — saying "OrthoSolid" over a
  // customer's logo is the one thing whitelabeling exists to avoid.
  const alt = showCompanyLogo
    ? userData?.company?.name || t('companies.whitelabel.logo.label')
    : t('brand.logoAlt');

  return (
    <Link href={backButton ? DEMO_PATH : `${HOME_PATH}`} target='_parent'>
      <Image
        src={showCompanyLogo ? companyLogo : '/static/logo.svg'}
        alt={alt}
        height={height}
        width={height * 5.16}
        // A company logo is not the OrthoSolid aspect ratio, so it is bounded by
        // height and left to find its own width instead of being stretched.
        style={showCompanyLogo ? { width: 'auto', height, objectFit: 'contain' } : undefined}
        unoptimized
        unselectable='on'
      />
    </Link>
  );
};

export default Logo;
